module.exports = __webpack_public_path__ + "static/img/state0.ef9278cb.png";